import { render, staticRenderFns } from "./titiles.vue?vue&type=template&id=6cf1a3cc&scoped=true&"
import script from "./titiles.vue?vue&type=script&lang=js&"
export * from "./titiles.vue?vue&type=script&lang=js&"
import style0 from "./titiles.vue?vue&type=style&index=0&id=6cf1a3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf1a3cc",
  null
  
)

export default component.exports